import { Icon } from "@iconify/react";

/**
 * Material Symbols (rounded) via Iconify.
 * Mappt sowohl DEVICES.key (de) als auch DEVICES.icon (engl./intern) -> material-symbols:*.
 * Fallback: "kitchen-rounded".
 *
 * Hinweis:
 * - Namen in Material Symbols nutzen oft Bindestriche: oven_gen -> oven-gen, toaster_oven -> toaster-oven.
 * - Nicht alle speziellen Küchengeräte existieren; dafür sind Näherungen gewählt.
 */
const MAP = {
  // --- Keys (deutsch) ---
  herd: "material-symbols:oven-rounded",
  ofen: "material-symbols:oven-gen-rounded",     // Material Symbols: oven_gen
  mikrowelle: "material-symbols:microwave-rounded",
  ruehrgeraet: "material-symbols:blender-rounded",   // Näherung (Mixer)
  mixer: "material-symbols:blender-rounded",
  puerierstab: "material-symbols:blender-rounded",   // Näherung (Handblender)
  fritteuse: "material-symbols:soup-kitchen-rounded",// Näherung
  airfryer: "material-symbols:toaster-oven-rounded", // Näherung
  grill: "material-symbols:outdoor-grill-rounded",
  thermomix: "material-symbols:blender-rounded",     // Näherung

  // --- Eure bisherigen DEVICES.icon-Strings ---
  "stove": "material-symbols:oven-rounded",
  "toaster-oven": "material-symbols:toaster-oven-rounded",
  "microwave": "material-symbols:microwave-rounded",
  "screw-machine-flat-top": "material-symbols:blender-rounded", // Ersatz
  "blender": "material-symbols:blender-rounded",
  "blender-outline": "material-symbols:blender-rounded",
  "fridge-top": "material-symbols:kitchen-rounded",             // Ersatz
  "air-filter": "material-symbols:toaster-oven-rounded",        // Airfryer-Näherung
};

// gut sichtbarer Fallback
const FALLBACK = "material-symbols:kitchen-rounded";

export default function KitchenIcon({ type, size = 18, color = "#79797a", style }) {
  const key = String(type ?? "").toLowerCase().trim();

  // Falls bereits ein kompletter Material-Symbol-Token übergeben wurde, direkt nehmen:
  const token = key.includes(":") ? key : (MAP[key] || FALLBACK);

  return (
    <Icon
      icon={token}
      width={size}
      height={size}
      color={color}
      style={{ display: "inline-block", verticalAlign: "middle", ...style }}
    />
  );
}
